import React from "react";
import "./Signup.css";
import { AppModal } from "../Modals/TextAreaModal";
import { SignupForm } from "./SignupForm";

import { SignupInfo } from "./SignupInfo";

import { SignupCodeCheck } from "./SignupCodeCheck";
import ApiError from "../Error/ApiError.js";

import FadeIn from "react-fade-in";
import LoadAnim from "../App/LoadAnim.js";

//Signup is wrapper, contains state
//SignupInfo displays the state information - has button that leads to SignupForm
//SignupForm takes input from user, how many tickets to buy, person info - returns information to Signup.js state
//Seater - recieves personinfo from Signup.js state, user selects seat. This is reserved for 10 minutes, tracked by Signup.
// If 10 minutes are up, user must be sent back to Seater if he has progressed but not completed signup
//SignupConfirm - user gets overview of seat number, price and persons, must hit confirm
//SignupComplete -Thank you for reserving screen. Email has been sent, seat has been tagged reserved

export class Signup extends React.Component {
  constructor(props) {
    super(props);

    //State storage - should be hooked up with mongoose

    //We use OnLoadPost to get latest stored DB post. Intended to use with cancel button.
    this.state = {
      signupPage: null,
      title: "Påmelding",
      post: "",
      signupConfirmed: false,
      tooYoung: false,
      showModal: false,

      //Navigation
      signupStart: false,
      signupCodeValidated: false,
      p1Email: "",
      guid: "",

      numPersons: 1,

      auth: false,
      error: false
    };

    //Bindings
    this.setPost = this.setPost.bind(this);
    this.getSignupPage = this.getSignupPage.bind(this);
    this.changePost = this.changePost.bind(this);
    this.cancelPost = this.cancelPost.bind(this);
    this.savePost = this.savePost.bind(this);
    this.modalPop = this.modalPop.bind(this);
    this.changeNumPersons = this.changeNumPersons.bind(this);
    this.setSignupStatus = this.setSignupStatus.bind(this);
    this.signupIsConfirmed = this.signupIsConfirmed.bind(this);
    this.setStartSignup = this.setStartSignup.bind(this);
    this.setP1Email = this.setP1Email.bind(this);
    this.setSignupCodeStatus = this.setSignupCodeStatus.bind(this);
  }

  //On mount we check if signup is open or closed

  async componentDidMount() {
    await this.getSignupPage();

    window.scrollTo(0, 0);
    this.setPost();
  }

  async setPost() {
    if (this.state.signupPage === undefined || this.state.signupPage === null) {
      this.setState({ post: "Noe gikk dessverre feil" }); //We change the post
      return;
    }

    if (this.state.signupPage.signupOpen === false) {
      this.setState({ post: this.state.signupPage.closedPost }); //We change the post
    }
    if (
      this.state.signupPage.signupOpen === true &&
      this.state.signupPage.signupOver === true
    ) {
      this.setState({ post: this.state.signupPage.overPost }); //We change the post
    }
  }

  async getSignupPage() {
    try {
      await fetch("/api/pagedata/getSignupPage", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          pragma: "no-cache",
          "cache-control": "no-cache"
        }
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data && data.length > 0 && data[0]) {
            this.setState({ signupPage: data[0] });
            this.setState({ post: data[0].post });
            this.setState({ updated: Date().slice(16, 24) });
            this.setState({ error: false });
          } else {
            // Handle empty database case
            this.setState({
              signupPage: {
                showSeatMap: false,
                signupOver: false,
                post: "Welcome to pLANner!"
              },
              post: "Welcome to pLANner!",
              updated: Date().slice(16, 24),
              error: false
            });
          }
        })
        .catch(err => {
          this.setState({ error: true });
          console.log(err);
        });
    } catch (err) {
      this.setState({ error: true });
      console.log(err);
    }
  }

  changePost(newPost) {
    //Takes an event param, done automatically by eventhandler - see AppModal for handleChange
    this.setState({ post: newPost }); //Updates the state with new value
  }

  changeNumPersons(num) {
    //Takes an event param, done automatically by eventhandler - see AppModal for handleChange
    if (num > 0 && num < 6) {
      console.log(num);
      this.setState({ numPersons: num }); //Updates the state with new value
    }
  }

  //Event for modal cancel button, sets Post state back to onLoadPost
  cancelPost(cancel) {
    this.setState({ post: this.state.onLoadPost });
    this.setState({ showModal: false });
  }
  //Event for modal save button, will push to DB, needs logic implementation
  savePost(newPost) {
    //Implement logic for saving post and refreshing the content
    console.log("saved the post");
    this.setState({ onLoadPost: newPost });
  }

  //Signup wont be open all year, so we can toggle this
  setSignupStatus(status) {
    this.setState({ signupOpen: status });
  }

  //When the confirm-dialogue is pressed in SignupForm we change these states
  signupIsConfirmed(e, isTooYoung) {
    this.setState({ tooYoung: isTooYoung, signupConfirmed: true });
  }

  setStartSignup(value) {
    if (this.state.signupStart === true) {
      this.setState({ signupStart: false });
      this.setState({ signupCodeValidated: false });
      this.setState({ guid: "" });
    } else {
      this.setState({ signupStart: true });
    }
  }

  modalPop(e) {
    //Trigger App's modal component... Toggles showModal true or false
    if (this.state.showModal === false) {
      this.setState({ showModal: true });
    } else {
      this.setState({ showModal: false });
    }
  }

  setP1Email(email) {
    this.setState({ p1Email: email });
  }

  setSignupCodeStatus(guid) {
    this.setState({ signupCodeValidated: true });
    this.setState({ guid: guid });
  }

  render() {
    return (
      <div>
        {this.state.error !== true && this.state.signupPage === null && (
          <LoadAnim />
        )}
        <FadeIn>
          {this.state.error && <ApiError />}
          {this.state.signupPage !== null && (
            <div className="Signup">
              <div>
                {this.state.signupStart === false && (
                  <SignupInfo
                    showSeatMap={this.state.signupPage.showSeatMap}
                    signupOver={this.state.signupPage.signupOver}
                    post={this.state.post}
                    setStartSignup={this.setStartSignup}
                    signupStart={this.state.signupStart}
                    foodTicket={this.state.signupPage.foodTicket}
                    signupOpen={this.state.signupPage.signupOpen}
                  />
                )}
                {this.state.signupStart === true &&
                  this.state.signupCodeValidated === false && (
                    <h3 className="CodeHeader">
                      Fyll inn din epost, og skriv inn koden du mottar.
                    </h3>
                  )}
                {this.state.signupStart === true &&
                  this.state.signupCodeValidated === false && (
                    <SignupCodeCheck
                      setP1Email={this.setP1Email}
                      setSignupCodeStatus={this.setSignupCodeStatus}
                    />
                  )}

                {this.state.auth === true && (
                  <button className="btn btno btn-info" onClick={this.modalPop}>
                    {" "}
                    Modal{" "}
                  </button>
                )}
                {this.state.showModal === true && (
                  <AppModal
                    post={this.state.post}
                    onLoadPost={this.state.onLoadPost}
                    onChange={this.changePost}
                    cancelPost={this.cancelPost}
                    savePost={this.savePost}
                    showModal={this.state.showModal}
                  />
                )}
              </div>
              {this.state.signupConfirmed === false &&
                this.state.signupPage.signupOpen === true &&
                this.state.signupStart === true &&
                this.state.signupCodeValidated && (
                  <SignupForm
                    guid={this.state.guid}
                    p1Email={this.state.p1Email}
                    setStartSignup={this.setStartSignup}
                    priceNoFood={this.state.signupPage.priceNoFood}
                    priceWithFood={this.state.signupPage.priceWithFood}
                    foodTicket={this.state.signupPage.foodTicket}
                    signupIsConfirmed={this.signupIsConfirmed}
                    numPersons={this.state.numPersons}
                    changeNumPersons={this.changeNumPersons}
                  />
                )}
            </div>
          )}

        {this.state.signupPage !== null && ( <p style={{textAlign: 'center'}}>Våre kjøpsbetingelser finner du <a target='_blank' href={window.origin + '/betingelser'}>her</a></p>)}
        </FadeIn>
      </div>
    );
  }
}

export default Signup;



// WEBPACK FOOTER //
// ./src/Components/Signup/Signup.js